export type DesktopNotificationPermissionStatus = NotificationPermission | 'unsupported' | 'pending';
export type DesktopNotificationMode = 'off' | 'native' | 'internal';
export function isDesktopNotificationMode(mode?: string | null): mode is DesktopNotificationMode {
  return Boolean(mode && ['off', 'native', 'internal'].includes(mode));
}
